import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'hourToDay'
})
export class HourToDayPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    if (value > 0) {
      return value / 24;
    }
    return 0;
  }

}
